module.exports = __webpack_public_path__ + "static/img/zichang.2780cad.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/font/zichang.png
// module id = HXbj
// module chunks = 1